import { NHDM_LOGIN } from '../constants';
import fetchWithRefresh from '../fetchWithRefresh';

interface Body {
    txn_id: string;
    health_id: string;
}

interface Response {
    skip_state: string;
    profile_created: boolean;
    oid: string;
    uuid: string;
    health_id: string;
    healthId_number: string;
    name: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    gender: string;
    day_of_birth: string;
    month_of_birth: string;
    year_of_birth: string;
    pincode: string;
    error?: string;
}

export const loginAbhaProfile = (
    docid: string,
    clinicid: string,
    body: Body,
): Promise<Partial<Response>> => {
    return fetchWithRefresh(NHDM_LOGIN, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
            'client-id': 'doc-web-new',
            'doc-id': docid,
            'clinic-id': clinicid,
        },
    }).then((res) => res.json());
};
